
import Vue from "vue";
import LocationsService from "../../services/LocationsService";
import CompaniesService from "../../services/CompanyService";
import CreateEditFeatureModal from "./CreateEditFeatureModal.vue";
import draggable from "vuedraggable";

export default Vue.extend({
  components: { CreateEditFeatureModal, draggable },
  data() {
    return {
      loading: false,
      enableField: true,
      features: [] as any,
      modalOpen: false,
      editFeature: null,
      deleting: "",
      featureType: "location" as "location" | "company",
      searchQuery: "",
      featureStats: null as any,
      featureStatTooltips: {
        interactedCompanies:
          "Count of companies where this feature flag was toggled at least once at any point. This includes companies that may be currently enabled or currently disabled.",
        interactedLocations:
          "Count of locations where this feature flag was toggled at least once at any point. This includes locations that may be currently enabled or currently disabled.",
        enabledCompanies:
          "Count of companies where this feature flag is currently enabled.",
        enabledLocations:
          "Count of individual locations where this feature flag is currently enabled.",
        totalEnabledLocations:
          "Count of individual enabled locations plus the location count of companies where this feature is enabled company-wide.",
      },
    };
  },

  computed: {
    filteredFeatures() {
      const features: any[] = this.$data.features;
      const searchQuery: string = this.$data.searchQuery;

      if (!searchQuery.trim()) {
        return features;
      }

      const query = searchQuery.toLowerCase().trim();
      return features.filter((feature: any) => {
        return (
          feature.name.toLowerCase().includes(query) ||
          feature.details.heading.toLowerCase().includes(query) ||
          feature.details.body.toLowerCase().includes(query) ||
          feature.key?.toLowerCase().includes(query)
        );
      });
    },
  },

  methods: {
    toggleField() {},
    created(feat: any) {
      this.features.unshift(feat);
    },
    updated(feat: any) {
      const index = this.features.findIndex((f: any) => f._id === feat._id);
      this.features.splice(index, 1, feat);
    },
    edit(feat: any) {
      this.editFeature = feat;
      this.modalOpen = true;
    },
    close() {
      this.modalOpen = false;
      this.editFeature = null;
    },
    async deleteFeat(feat: any) {
      this.deleting = feat._id;
      await LocationsService.deleteLabsFeature(feat._id);
      this.deleting = "";
      this.features.splice(
        this.features.findIndex((f: any) => feat._id === f._id),
        1
      );
    },
    async dragged(e: any) {
      this.$nextTick().then(async () => {
        let before = this.features[e.moved.newIndex - 1];

        await LocationsService.updateLabsFeaturePosition(
          this.features[e.moved.newIndex]._id,
          before && before._id
        );
      });
    },
    async showStats(feature: any) {
      this.featureStats = { featureName: feature.name };
      await this.$nextTick();
      const modal: any = this.$refs.featureStatsModal;
      modal.show();
      const response = await CompaniesService.getFeatureStats(
        feature.key,
        feature.type
      );
      this.featureStats = { ...response.data, featureName: feature.name };
    },
  },
  watch: {
    featureType: {
      async handler(type) {
        try {
          this.loading = true;
          this.features = (await LocationsService.getLabsFeatures(type)).data;
        } catch (error) {
        } finally {
          this.loading = false;
        }
      },
      immediate: true,
    },
  },
  filters: {
    date(v: string) {
      return v ? new Date(v).toDateString() : "-";
    },
  },
});
